<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" lg="6" class="mb-4 mt-4">
      <PageTitle title="Cadastrar produtos" />
    </b-col>
    <b-col cols="12" lg="6" class="mb-4">
      <span class="btn btn-success float-right text-uppercase" @click="verProdutos()">
        Ver meus produtos cadastrados
      </span>
    </b-col>

    <b-col cols="12" lg="9" class="mb-4">
      <label>Nome do produto <span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.produto" placeholder="Nome do produto">
      <span class="text-danger d-inline" v-if="errorFields.produto">Informe o nome do produto</span>
    </b-col>

    <b-col cols="12" lg="3" class="mb-4">
      <label>Código de barra <span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.codbar" @blur="buscarCodBar()" placeholder="Código de barras">
      <span class="text-danger d-inline" v-if="errorFields.codbar">Informe o Cód. barras</span>
    </b-col>

    <b-col cols="12" lg="3" class="mb-4">
      <label>Marca <span class="text-danger d-inline">*</span></label>
      <v-select
        label="marca"
        v-model="dataProduct.marca"
        :options="brand"
        :loading="loadingDepartments"
        placeholder="Selecione a marca"
        @search="addOption"
      />
      <span class="text-danger d-inline" v-if="errorFields.marca">Informe a marca</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Unidade de medida <span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.uni_med" placeholder="Un, Kg, Cm...">
      <span class="text-danger d-inline" v-if="errorFields.uni_med">Informe a Unidade de medida</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Peso (Kg)<span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.peso" placeholder="Peso do produto" v-money="formatTipo">
      <span class="text-danger d-inline" v-if="errorFields.peso">Informe o peso do produto</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Altura (Cm)<span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.altura" placeholder="Altura do produto" v-money="formatTipo">
      <span class="text-danger d-inline" v-if="errorFields.altura">Informe a altura</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Largura (Cm)<span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.largura" placeholder="Largura do produto" v-money="formatTipo">
      <span class="text-danger d-inline" v-if="errorFields.largura">Informe a largura</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Comprimento (Cm)<span class="text-danger d-inline">*</span></label>
      <input type="text" class="form-control" v-model="dataProduct.comprimento" placeholder="Comprimento do produto" v-money="formatTipo">
      <span class="text-danger d-inline" v-if="errorFields.comprimento">Informe o comprimento</span>
    </b-col>

    <b-col cols="6" lg="3" class="mb-4">
      <label>Qtd Metro² Caixa<span class="text-danger d-inline ml-2">(Pisos e revestimento)</span></label>
      <input type="text" class="form-control" v-model="dataProduct.qtd_metros" placeholder="m² caixa piso" v-mask="['#.##', '##.##']">
    </b-col>

    <b-col cols="12" class="mb-2">
      <label>Descrição do produto (Opcional)</label>
      <textarea class="form-control" rows="3" placeholder="Descrição do produto" v-model="dataProduct.descricao"></textarea>
    </b-col>

    <b-col cols="12" class="mb-2 mt-2">
      <label>Categoria: <span class="text-danger d-inline">*</span></label>
      <span class="ml-2"><b>{{categoria}}</b></span>
      <span class="btn btn-primary float-right mb-1" @click="limparCategoria()">Limpar</span>

      <select class="custom-select mb-3" @change="selectId()" v-model="categoriaSelect">
          <option selected value="">-- Selecione a categoria {{count+1}} --</option>
          <option v-for="(item, i) in categorias" :key="i" :value="item">{{item.nome_departamento}}</option>
      </select>
      <span class="text-danger d-inline" v-if="errorFields.departamento_id">Informe a categoria</span>
    </b-col>

    <b-col cols="12" lg="6" class="mt-2">
      <label>Ficha(s) tec. (Opcional)</label>
      <span class="btn btn-primary float-right" @click="openModalFicha()">+</span>

      <table class="table table-striped table-bordered mt-2">
        <thead>
          <tr>
          <th scope="col">Tipo</th>
          <th scope="col">Descrição</th>
          <th class="text-center" scope="col">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in dataProduct.fichas" :key="i" v-show="dataProduct.fichas && dataProduct.fichas.length > 0">
            <td>
              <input type="text" class="form-control" v-model="dataProduct.fichas[i].tipo">
            </td>
            <td>
              <input type="text" class="form-control" v-model="dataProduct.fichas[i].descricao">
            </td>
            <td class="text-center" colspan="3">
              <span class="cursor-pointer" style="color:red" @click="removerFicha(i)">
                <i class="fas fa-trash"></i>
              </span>
            </td>
          </tr>
          <tr v-if="dataProduct.fichas && dataProduct.fichas.length == 0">
            <td colspan="3">
              <span>Sem ficha tec. cadastrada!</span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>

    <b-col cols="12" lg="6" class="mt-2">
      <label>Imagem do produto:</label>
      <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage()" class="form-control">
      <span class="text-danger d-inline" v-if="errorFields.fotos">Informe a(s) foto(s)</span>

      <b-row>
        <b-col cols="2" class="mt-2 mr-2 text-center" v-for="(item, i) in dataProduct.fotos" :key="i">
          <span class="cursor-pointer" style="color:red" @click="removerFoto(i)">
            <i class="fas fa-times-circle"></i>
          </span>
          <br>
          <img
            :src="formatUrl(item)"
            :alt="dataProduct.produto+' - '+i"
            @click="openImg(formatUrl(item))"
            width="70"
            class="cursor-pointer"
          >
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <span class="text-danger">Produto para análise, disponível após aprovação*</span>
    </b-col>

    <b-col cols="12" class="text-center mt-4 mb-5">
      <b-button v-if="whatClerkPermission()" @click="savingProduct()" variant="success" class="pl-5 pb-2 pt-2 pr-5">
        <i class="mr-2 fas fa-paper-plane"></i>
        Cadastrar produto
      </b-button>
    </b-col>

    <b-modal
      title="Foto do produto"
      size="xl"
      id="modalImagem"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
        <b-row>
            <b-col cols="12">
                <img :src="urlImagem" style="width: 100%;">
            </b-col>
        </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import PageTitle from '../../../components/PageTitle.vue';
import { mapState } from 'vuex';
import VideoManual from '@/components/VideoManual.vue';
import makeToast from 'Mixins/makeToast';
import { mapActions } from 'vuex';
import SelectItems from '../../../components/Inputs/SelectItems.vue';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import UserTypes from '@/enums/UserTypes';

export default {
  mixins: [makeToast],

  components: {
    PageTitle,
    VideoManual,
    SelectItems
  },

  data() {
    return {
      loadingDepartments: false,
      setLink: false,
      brand: [],
      switchFilter: null,
      fields: {
        name: '',
        departments1: '',
        departments2: '',
        departments3: '',
        departments4: '',
        departments5: '',
        departments6: '',
        subCategory4: '',
        family: '',
        brand: '',
      },
      categoriaSelect: '',
      categoria: '',
      urlImagem: '',
      categorias: [],
      count: 0,
      valid: false,
      dataProduct: {
        produto: null,
        codbar: null,
        marca: null,
        uni_med: null,
        peso: null,
        altura: null,
        largura: null,
        comprimento: null,
        departamento_id: null,
        qtd_metros: null,
        lojista_id: null,
        fichas: [],
        fotos: []
      },
      errorFields: {
        produto: false,
        codbar: false,
        marca: false,
        uni_med: false,
        peso: false,
        altura: false,
        largura: false,
        comprimento: false,
        departamento_id: false,
        fichas: false,
        fotos: false
      },
      formatTipo: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.buscarCategoria(0);
  },

  mounted() {
    this.getBrand();
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.fields = this.value || {};
      },
    },
    fields: {
      deep: true,
      handler() {
        this.$emit('update:value', this.fields);
      },
    },
    'fields.departments1': function () {
      this.families = [];
      this.fields.departments2 = '';

      if(this.fields.departments1.link == 1) {
        this.fields.family = this.fields.departments1.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments1.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments1, 'departments2');
    },
    'fields.departments2': function () {
      this.families = [];
      this.fields.departments3 = '';

      this.fields.tipo = this.fields.departments2.tipo;

      if(this.fields.departments2.link == 1) {
        this.fields.family = this.fields.departments2.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments2.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments2, 'departments3');
    },
    'fields.departments3': function () {
      this.families = [];
      this.fields.departments4 = '';

      if(this.fields.departments3.link == 1) {
        this.fields.family = this.fields.departments3.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments3.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments3, 'departments4');
    },
    'fields.departments4': function () {
      this.families = [];
      this.fields.departments5 = '';

      if(this.fields.departments4.link == 1) {
        this.fields.family = this.fields.departments4.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments4.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments4, 'departments5');
    },
    'fields.departments5': function () {
      this.families = [];
      this.fields.departments6 = '';

      if(this.fields.departments5.link == 1) {
        this.fields.family = this.fields.departments5.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments5.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments5, 'departments6');
    },
    'fields.departments6': function () {
      this.families = [];
      this.fields.departments7 = '';

      if(this.fields.departments6.link == 1 && this.fields.departments6.link != null) {
        this.fields.family = this.fields.departments6.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments6.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments6, 'departments7');
    },
    'fields.family': function () {
      this.$emit('searchProductsByFamilyId', this.fields.family);
    },
    'fields.brand': function () {
      this.$emit('searchProductsByFamilyId', this.fields.brand.marca);
    },
  },

  methods: {
    ...mapActions('shopkeeper', ['getAllBrand',]),
    getBrand(){
      this.getAllBrand()
        .then((response) => {
          const brand = response.data.data;
          localStorage.setItem('brands', JSON.stringify(brand));
        })
        .finally(() => {
        this.loadingDepartments = false;
        });
    },

    addOption(search) {
      this.brand = [];

      if (search.length >= 2) {
        const storedBrands = JSON.parse(localStorage.getItem('brands'));
        if (storedBrands) {
          this.brand = storedBrands.filter(brand => brand.marca.toLowerCase().includes(search.toLowerCase()));
        }

        this.brand.unshift({ marca: search });
      }
    },

    selectId() {
      const item = this.categoriaSelect;

      if(item && item.nome_departamento) {
        if(this.setLink == false) {
          const seta = this.count == 0 ? '' : ' -> ';
          this.categoria = this.categoria+seta+item.nome_departamento;
        } else {
          const partes = this.categoria.split(' -> ');

          partes.pop();
          partes.push(item.nome_departamento);

          this.categoria = partes.join(' -> ');
        }
      }

      if(item.link == true) {
        this.dataProduct.departamento_id = item.id;

        this.setLink = true;
      } else {

        if(item && item.nome_departamento) {

          this.count = this.count +1;
          this.categoriaSelect = '';

          this.buscarCategoria(item.id);

          this.setLink = false;
        }
      }
    },
    limparCategoria() {
      this.setLink = false;
      this.count = 0;
      this.categoriaSelect = '';
      this.categoria = '';
      this.dataProduct.departamento_id = null;

      this.buscarCategoria(0);
    },
    openImg(url) {
      this.urlImagem = url;
      this.$bvModal.show('modalImagem');
    },
    savingProduct() {
      const valid = this.formValidate();
      if(valid == true) {
          this.makeToast('Oops!', 'Corrija os erros acima para cadastrar o produto!', 'danger');
          return;
      }

      this.dataProduct.marca = typeof(this.dataProduct.marca) == 'object' ? this.dataProduct.marca.marca : this.dataProduct.marca;
      this.dataProduct.lojista_id = this.userTypeId();

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/salvarNovoProduto', this.dataProduct)
      .then((response) => {
        if(response.data.error == false) {
          this.makeToast('Sucesso!', 'Produto cadastrado com sucesso!', 'success');
          this.makeToast('Sucesso!', 'Você já pode cadastrar um novo produto!', 'success');

          this.limpaProduto();
          this.limparCategoria();
        } else {
          this.makeToast('Oops!', 'Ocorreu um erro ao cadastrar o produto!', 'danger');
        }
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    buscarCategoria(id) {

      const data = {
        id: id,
        user_id: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategorias', data)
        .then((response) => {
          this.categorias = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    removerFicha(i) {
      this.dataProduct.fichas = this.dataProduct.fichas.filter((elemento, index) => index !== i);
    },
    removerFoto(i) {
      this.dataProduct.fotos = this.dataProduct.fotos.filter((elemento, index) => index !== i);
    },
    buscarCodBar() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCodBar', this.dataProduct.codbar)
        .then((response) => {
          if(response.data.id) {
            this.dataProduct.codbar = null;
            this.makeToast('Oops!', 'Esse código de barras já existe, informe outro produto!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileNewProduct', formData)
      .then((response) => {
        const file = response.data.data;
        this.dataProduct.fotos.push(file)
      })
      .catch(() => {
          this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
      })
      .finally(() => {
          this.$store.dispatch('endLoader');
      });
    },
    openModalFicha() {
      this.dataProduct.fichas.push({tipo: null, descricao: null});
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
    verProdutos() {
      this.$router.push({name: 'lojista-produtos-status'});
    },
    formValidate() {
      this.limpaErro();
      var valid = false;

      if(this.dataProduct.produto == null || this.dataProduct.produto == '') {
        this.errorFields.produto = true;
        valid = true;
      }
      if(this.dataProduct.codbar == null || this.dataProduct.codbar == '') {
        this.errorFields.codbar = true;
        valid = true;
      }
      if(this.dataProduct.marca == null || this.dataProduct.marca == '') {
        this.errorFields.marca = true;
        valid = true;
      }
      if(this.dataProduct.uni_med == null || this.dataProduct.uni_med == '') {
        this.errorFields.uni_med = true;
        valid = true;
      }
      if(this.dataProduct.peso == null || this.dataProduct.peso == '0.00') {
        this.errorFields.peso = true;
        valid = true;
      }
      if(this.dataProduct.altura == null || this.dataProduct.altura == '0.00') {
        this.errorFields.altura = true;
        valid = true;
      }
      if(this.dataProduct.largura == null || this.dataProduct.largura == '0.00') {
        this.errorFields.largura = true;
        valid = true;
      }
      if(this.dataProduct.comprimento == null || this.dataProduct.comprimento == '0.00') {
        this.errorFields.comprimento = true;
        valid = true;
      }
      if(this.dataProduct.departamento_id == null || this.dataProduct.departamento_id == '') {
        this.errorFields.departamento_id = true;
        valid = true;
      }
      if(this.dataProduct.fotos.length == 0) {
        this.errorFields.fotos = true;
        valid = true;
      }
      return valid;
    },
    limpaProduto(){
      this.dataProduct.produto = null;
      this.dataProduct.codbar = null;
      this.dataProduct.marca = null;
      this.dataProduct.uni_med = null;
      this.dataProduct.peso = null;
      this.dataProduct.altura = null;
      this.dataProduct.largura = null;
      this.dataProduct.comprimento = null;
      this.dataProduct.descricao = null;
      this.dataProduct.departamento_id = null;
      this.dataProduct.lojista_id = null;
      this.dataProduct.qtd_metros = null;
      this.dataProduct.fichas = [];
      this.dataProduct.fotos = [];
    },
    limpaErro(){
      this.errorFields.produto = false;
      this.errorFields.codbar = false;
      this.errorFields.marca = false;
      this.errorFields.uni_med = false;
      this.errorFields.peso = false;
      this.errorFields.altura = false;
      this.errorFields.largura = false;
      this.errorFields.comprimento = false;
      this.errorFields.departamento_id = false;
      this.errorFields.fichas = false;
      this.errorFields.fotos = false;
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.CRIAR_PRODUTO);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    }
  }
}
</script>
